import type { Container } from 'inversify';
import { container } from '@shared/common/dependency-injection/domain/container';
import { ClientCoreAppModule } from '@client/composition/core/client-core.app-module';
import { diContainerModule } from '@client/composition/core/client-di.container-module';
import {
  AppModuleLoader,
  DIDependencyTypes,
  diContainerModule as baseDIContainerModule,
} from '@kiplin/web-common/dependency-injection';

let isLoaded = false;

export async function loadContainer(): Promise<Container> {
  if (!isLoaded) {
    await container.load(baseDIContainerModule, diContainerModule);
    if (container.isBound(DIDependencyTypes.Container)) {
      await container.unbind(DIDependencyTypes.Container);
    }
    container.bind(DIDependencyTypes.Container).toConstantValue(container);

    const appModuleLoader = container.get<AppModuleLoader>(DIDependencyTypes.AppModuleLoader);
    await appModuleLoader.load(ClientCoreAppModule);

    isLoaded = true;
  }

  return container;
}
